// src/utils/auth.js
//import Cookies from 'js-cookie'
//const TokenKey = 'auth_token'

export function getToken() {
    return sessionStorage.getItem('authToken')
  //return Cookies.get(TokenKey)
}

export function setToken(token) {

    return sessionStorage.setItem('authToken', token)
  //return Cookies.set(TokenKey, token)
}

export function removeToken() {

  return sessionStorage.removeItem('authToken')
  //return Cookies.remove(TokenKey)
}